import axios from 'axios';
import queryString from 'query-string';

const BABYFACE_URL = `${process.env.REACT_APP_BACKEND_URL}`;

// COMMON
export const tempPrice = ({
  itemId,
  optionIds,
  voucherIds,
  includeShippingFee,
}) =>
  axios.post(`${BABYFACE_URL}/order/test-price?includeShippingFee=${includeShippingFee}`, {
    items: [
      {
        id: itemId,
        optionIds,
      },
    ],
    voucherIds,
  });

export const getInfo = () => axios.get(`${BABYFACE_URL}/user/current-user`);

export const putCurrentEnduserInfo = (enduserInfo) =>
  axios.put(`${BABYFACE_URL}/enduser/current-user`, enduserInfo);

export const putCurrentUserContract = (contract) =>
  axios.put(`${BABYFACE_URL}/enduser/current-user/contract`, contract);

export const getUltrasound = ({ itemId }) =>
  axios.get(`${BABYFACE_URL}/ultrasound/request/${itemId}`);

// AUTH API
export const babyfaceSignup = ({
  business,
  email,
  mobile,
  password,
  name,
  allowMarketing,
}) =>
  axios.post(`${BABYFACE_URL}/account/sign-up`, {
    business,
    email,
    mobile,
    password,
    name,
    allowMarketing,
  });

export const babyfaceSignin = ({ email, password }) =>
  axios.post(`${BABYFACE_URL}/login`, {
    email,
    password,
  });

export const babyfaceSigninNaver = ({ accessToken, businessName }) =>
  axios.post(
    `${BABYFACE_URL}/social/login/naver?${queryString.stringify({
      accessToken: accessToken,
      businessName: businessName,
    })}`,
  );

// 공식 문서 3.4.4: 네이버 토큰 교환 API (백엔드에서 처리)
export const babyfaceSigninNaverWithCode = ({ code, state, businessName }) =>
  axios.post(
    `${BABYFACE_URL}/social/login/naver-code?${queryString.stringify({
      code: code,
      state: state,
      businessName: businessName,
    })}`,
  );

export const babyfaceSignout = () =>
  axios.put(`${BABYFACE_URL}/account/logout`);

export const babyfaceWithdrawal = ({ detailReason, reason }) =>
  axios.delete(`${BABYFACE_URL}/account/withdrawal`, {
    data: { business: 'BABYFACE', detailReason, reason },
  });

export const findEmail = ({ name, mobile }) =>
  axios.get(
    `${BABYFACE_URL}/user/find-email?${queryString.stringify({
      name,
      mobile,
    })}`,
  );
export const findPassword = ({ email, name }) =>
  axios.get(
    `${BABYFACE_URL}/user/find-password?${queryString.stringify({
      email,
      name,
    })}`,
  );
export const checkResetCode = ({ code }) =>
  axios.get(
    `${BABYFACE_URL}/any/password-reset?${queryString.stringify({ code })}`,
  );
export const passwordReset = ({ code, password }) =>
  axios.put(
    `${BABYFACE_URL}/any/password-reset?${queryString.stringify({ code })}`,
    { password },
  );

// 휴대폰 인증 관련
export const issueMobileCode = ({ message, phoneNumber }) =>
  axios.post(
    `${BABYFACE_URL}/any/validation/mobile
`,
    {
      message: message,
      phoneNumber: phoneNumber,
    },
  );

export const validationMobileCode = ({ validationId, validationCode }) =>
  axios.put(
    `${BABYFACE_URL}/any/validation/mobile/${validationId}?${queryString.stringify(
      {
        validationCode,
      },
    )}`,
  );

// HOME
export const getReviewSearch = ({
  criteria,
  sortBy,
  sortDirection,
  page,
  size,
  getAllImages,
}) =>
  axios.get(
    `${BABYFACE_URL}/review/search?${queryString.stringify({
      criteria,
      sortBy,
      sortDirection,
      page,
      size,
      getAllImages,
    })}`,
  );

export const getReviewCount = () =>
  axios.get(
    `${BABYFACE_URL}/review/count?${queryString.stringify({
      categoryType: 'ALL',
    })}`,
  );

export const putReviewLike = ({ id }) =>
  axios.put(`${BABYFACE_URL}/review/${id}/like`);

export const putReviewUnlike = ({ id }) =>
  axios.put(`${BABYFACE_URL}/review/${id}/unlike`);

// REVIEW
export const getReviewable = () =>
  axios.get(`${BABYFACE_URL}/review/purchased-items/reviewable`);

export const getCurrentUserReview = () =>
  axios.get(`${BABYFACE_URL}/review/current-user`);

export const getDetailReview = ({ id }) =>
  axios.get(`${BABYFACE_URL}/review/${id}`);

export const getPurchasedInfo = ({ purchasedItemId, reviewCategoryType }) =>
  axios.get(
    `${BABYFACE_URL}/purchased-item/${purchasedItemId}?${queryString.stringify({
      reviewCategoryType,
    })}`,
  );

export const getPurchasedImage = ({ purchasedItemId }) =>
  axios.get(`${BABYFACE_URL}/review/${purchasedItemId}/default-image`);

export const postReview = ({
  purchasedItemId,
  defaultImageIds,
  fd,
  reviewCategoryType,
}) =>
  axios.post(
    `${BABYFACE_URL}/review/purchased/${purchasedItemId}?${queryString.stringify(
      {
        defaultImageIds,
        reviewCategoryType,
      },
    )}`,
    fd,
  );

export const putReview = ({ id, reviewImageIdsToDelete, fd }) =>
  axios.put(
    `${BABYFACE_URL}
/review/${id}?${queryString.stringify({
      reviewImageIdsToDelete,
    })}
`,
    fd,
  );

// SERVICE
export const getServiceImage = ({ itemId }) =>
  axios.get(`${BABYFACE_URL}/item-preview/item/${itemId}`);

// ORDER
export const item = () => axios.get(`${BABYFACE_URL}/item/conversion`);
export const option = ({ itemId }) =>
  axios.get(`${BABYFACE_URL}/option/item/${itemId}`);
export const coupon = ({ code }) =>
  axios.get(
    `${BABYFACE_URL}/coupon?${queryString.stringify({
      code,
    })}`,
  );
export const subTempPrice = ({ itemId, optionIds, voucherId }) =>
  axios.post(`${BABYFACE_URL}/order/test-price`, {
    items: [
      {
        id: itemId,
        optionIds: [optionIds],
      },
    ],
    voucherIds: [voucherId],
  });
export const createOrder = ({
  email,
  name,
  mobile,
  zipcode,
  address,
  detailAddress,
  message,
  note,
  itemId,
  optionIds,
  babyGender,
  voucherIds,
  hospitalName,
  paymentMethod,
  selectedFrame,
  refundAccount,
  refundBank,
  refundHolder,
}) =>
  axios.post(`${BABYFACE_URL}/order`, {
    contactInfo: {
      zipcode: zipcode,
      address: address,
      detailAddress: detailAddress,
      contactEmail: email,
      contactName: name,
      mobile: mobile,
    },
    items: [
      {
        id: itemId,
        optionIds: optionIds,
        additionalInfo: {
          infoType: 'conversion',
          message: message,
          note: note,
          babyGender: babyGender,
          hospitalName: hospitalName,
          imageFrameAlias: selectedFrame,
        },
      },
    ],
    paymentMethod: paymentMethod,
    refundAccount,
    refundBank,
    refundHolder,
    voucherIds,
  });

export const uploadUltra = ({ reqId, fd }) =>
  axios.post(`${BABYFACE_URL}/ultrasound/request/${reqId}`, fd);

export const checkMessage = ({ text }) =>
  axios.get(
    `${BABYFACE_URL}/requests/message/unsupported-characters?${queryString.stringify(
      {
        text,
      },
    )}`,
  );

export const getPaymentInfo = (paymentKey) =>
  axios.get(
    `${BABYFACE_URL}/order/payment?${queryString.stringify({
      paymentKey,
    })}`,
  );

export const getOrderCheckBefore = () =>
  axios.get(`${BABYFACE_URL}/order/check-before`);

// VOUCHER_PURCHASE
export const postVoucherOrderTemplate = ({
  voucherName,
  itemId,
  itemOptionIds,
}) =>
  axios.post(`${BABYFACE_URL}/order/match/item-voucher`, {
    voucherName,
    itemId,
    itemOptionIds,
  });

export const postPrePurchaseOrder = ({
  prePurchaseItemId,
  prePurchaseOptionIds,
  name,
  email,
  mobile,
  paymentMethod,
  voucherIds,
}) =>
  axios.post(`${BABYFACE_URL}/order`, {
    contactInfo: {
      contactName: name,
      contactEmail: email,
      mobile,
    },
    items: [
      {
        id: prePurchaseItemId,
        optionIds: prePurchaseOptionIds,
        additionalInfo: {
          infoType: 'voucher',
          senderName: name,
          recipientName: name,
          recipientMobile: mobile,
        },
      },
    ],
    paymentMethod,
    voucherIds,
  });

// PRESENT
export const tempPresentPrice = ({ subItemId, subOptionIds }) =>
  axios.post(`${BABYFACE_URL}/order/test-price`, {
    items: [
      {
        id: subItemId,
        optionIds: subOptionIds,
      },
    ],
  });

export const presentOrderSubmit = ({
  name,
  mobile,
  email,
  recipientMessage: messageToRecipient,
  recipientMobile,
  recipientName,
  subItemId,
  subOptionIds,
  paymentMethod,
  voucherIds,
}) =>
  axios.post(`${BABYFACE_URL}/order`, {
    contactInfo: {
      contactName: name,
      contactEmail: email,
      mobile: mobile,
    },
    items: [
      {
        id: subItemId,
        optionIds: subOptionIds,
        additionalInfo: {
          infoType: 'voucher',
          messageToRecipient: messageToRecipient,
          recipientMobile,
          recipientName,
          senderName: name,
          senderMobile: mobile,
        },
      },
    ],
    paymentMethod: paymentMethod,
    voucherIds,
  });

export const putVoucherDelegate = ({ code, type }) =>
  axios.put(
    `${BABYFACE_URL}/purchased-voucher/delegate?${queryString.stringify({
      code,
      type,
    })}`,
  );

// MYPAGE API
export const changePassword = ({ oldPassword, password }) =>
  axios.put(`${BABYFACE_URL}/account/set-password`, {
    oldPassword,
    password,
  });

export const changeUserInfo = ({ mobile, name }) =>
  axios.put(`${BABYFACE_URL}/user/current-user`, {
    contactInfo: {
      mobile: mobile,
    },
    name,
  });

export const getDetailInfo = ({ id }) =>
  axios.get(`${BABYFACE_URL}/order/${id}`);

export const orderRefund = ({ id, amount }) =>
  axios.put(`${BABYFACE_URL}/order/${id}/refund`, {
    amount,
  });

// GIFT BOX
export const registerVoucher = ({ code }) =>
  axios.put(
    `${BABYFACE_URL}/purchased-voucher/delegate?${queryString.stringify({
      code,
    })}`,
  );

export const checkReceivedGift = () =>
  axios.get(`${BABYFACE_URL}/purchased-voucher/current-user/received`);

export const checkPurchasedGift = () =>
  axios.get(`${BABYFACE_URL}/purchased-voucher/current-user/purchased`);

export const refundGift = ({ id }) =>
  axios.put(
    `${BABYFACE_URL}/order/refund-item?${queryString.stringify({
      itemId: id,
    })}`,
  );

export const resendGift = ({ id, voucherOrderInfo }) =>
  axios.put(
    `${BABYFACE_URL}/purchased-voucher/${id}/resend-message`,
    voucherOrderInfo,
  );

export const giftOrderInfo = ({ code }) =>
  axios.get(
    `${BABYFACE_URL}/purchased-voucher/order-template?${queryString.stringify({
      code,
    })}`,
  );

export const getImage = ({ id }) =>
  axios.get(`${BABYFACE_URL}/image/${id}`, {
    responseType: 'blob',
  });

// REFUND
export const putForceRefund = (paymentKey) =>
  axios.put(
    `${BABYFACE_URL}/order/force-refund?${queryString.stringify({
      paymentKey,
    })}`,
  );

export const putRefundPayment = ({
  id,
  refundReason,
  holder,
  account,
  bankCode,
}) =>
  axios.put(`${BABYFACE_URL}/order/${id}/refund`, {
    amount: 0,
    reason: refundReason,
    holder,
    account,
    bankCode,
  });

export const putCheckAccountHolder = ({ bankCode, accountNumber }) =>
  axios.get(
    `${BABYFACE_URL}/order/payment/account-holder?${queryString.stringify({
      bankCode,
      accountNumber,
    })}`,
  );

export const getFrames = () => axios.get(`${BABYFACE_URL}/final-image/frame`);

export const getFrame = ({ selectedFrame }) =>
  axios.get(`${BABYFACE_URL}/final-image/frame/${selectedFrame}`);

export const putMessage = ({ id, message }) =>
  axios.put(`${BABYFACE_URL}/requests/inspector/${id}/user-message`, message, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const getThumbnail = ({ name }) =>
  axios.get(
    `${BABYFACE_URL}/review-category/name?${queryString.stringify({
      name,
    })}`,
  );

// MYPAGE
export const getVoucherCouponCount = () =>
  axios.get(`${BABYFACE_URL}/purchased-voucher/current-user/usable/count`);
export const getVoucherCouponList = ({ status }) =>
  axios.get(`${BABYFACE_URL}/purchased-voucher/current-user/${status}`);
export const postVoucherCoupon = ({ code }) =>
  axios.put(
    `${BABYFACE_URL}/purchased-voucher/delegate?${queryString.stringify({
      code,
    })}`,
  );
export const putVoucherCouponStatus = ({ id, status }) =>
  axios.put(
    `${BABYFACE_URL}/purchased-voucher/${id}/status/${status}`,
  );
export const getPayback = ({ reqId }) =>
  axios.get(`${BABYFACE_URL}/payback/item/${reqId}`);

export const getAccountHolder = ({ bankCode, accountNumber }) =>
  axios.get(
    `${BABYFACE_URL}/order/payment/account-holder?${queryString.stringify({
      bankCode,
      accountNumber,
    })}`,
  );

export const downloadFinalProductVideo = (id) =>
  axios.get(`${BABYFACE_URL}/final-product/video/${id}`);

/** clearface */
export const createClearfaceOrder = ({ files }) =>
  axios.post(BABYFACE_URL.concat(`/order/clearface`), files);

export const getClearfaceOrder = ({ id }) =>
  axios.get(BABYFACE_URL.concat(`/order/clearface/${id}`));

export const getCurrentUserOrder = () => 
  axios.get(BABYFACE_URL.concat('/order/current-user'));

export const getOngoingEvents = () =>
  axios.get(BABYFACE_URL.concat('/event'));

export const getAppliedEvents = () => 
  axios.get(BABYFACE_URL.concat('/event/participant'));

export const applyEvent = ({ eventId, status, orderInfoId }) => 
  axios.post(BABYFACE_URL.concat('/event/participant'), { eventId, status, orderInfoId });